module.exports = __webpack_public_path__ + "static/media/vnt-logo-white.f149ad76.svg";